export default __webpack_public_path__ + "img/banner-0.55e17636942bdebe11279cbfdc036bff.jpg";